import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import AdminLogin from './components/AdminLogin';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  
  // Initial Mock data matching user sports preferences
  const [parlays, setParlays] = useState([
    {
      id: 1,
      title: "MLB +100 EV Cash Slip",
      sport: "MLB",
      risk: "S-Tier",
      legs: [
        { team: "NY Yankees vs BOS Red Sox", market: "NRFI (No Run First Inning)", odds: "-115" },
        { team: "LA Dodgers vs SF Giants", market: "Dodgers Moneyline", odds: "-130" }
      ],
      totalOdds: "+215",
      status: "Active"
    },
    {
      id: 2,
      title: "Dota 2 Meta Draft Edge",
      sport: "ESPORTS",
      risk: "A-Tier",
      legs: [
        { team: "Team Liquid vs Team Falcons", market: "Map 1 Over 46.5 Kills", odds: "-110" },
        { team: "Tundra Esports vs Aurora", market: "Tundra Match Winner", odds: "-150" }
      ],
      totalOdds: "+218",
      status: "Active"
    }
  ]);

  return (
    <Router>
      <div style={{ minHeight: '100vh', backgroundColor: '#070906', color: '#fff' }}>
        <Navbar isAdmin={isAdmin} setIsAdmin={setIsAdmin} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route 
            path="/dashboard" 
            element={<Dashboard parlays={parlays} setParlays={setParlays} isAdmin={isAdmin} />} 
          />
          <Route 
            path="/admin" 
            element={isAdmin ? <Navigate to="/dashboard" /> : <AdminLogin setIsAdmin={setIsAdmin} />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;